import React, { useState } from 'react'

import FormPopUpEducation from './form/FormPopUpEducation'

import styles from './styles.module.scss'

const EducationBlock = ({
  setActiveBlock,
  setActivePopUp,
  checkDomenNameState,
  retake,
  setRetake,
  activeForm,
  setActiveForm,
  captchaSiteKey
}) => {
  const [season, setSeason] = useState(null)

  // const saveProject1 = () => {
  //   setActiveForm(true)
  //   setSeason(['РТУ МИРЭА', 'Образовательный проект Mabstudy'])
  // }

  return (
    <>
      {!activeForm ? (
        <div>
          <p onClick={() => setActivePopUp(false)} className={styles.wrapper_total_right_p1}>
            <span>&larr;</span>Вернуться назад
          </p>
          <p className={styles.wrapper_total_right_p2}>Выбери направление</p>
          <div className={styles.wrapper_total_text_education}>
            <div className={styles.wrapper_total_text_item}>
              <div>
                <p className={styles.wrapper_total_text_item_p1}>РТУ МИРЭА</p>
                <p className={styles.wrapper_total_text_item_p2}>Образовательный проект Mabstudy</p>
              </div>
              <div className={styles.wrapper_total_text_item_btn}>
                <a href='/students/mabstudy'>
                  Перейти <span>&rarr;</span>
                </a>
              </div>
            </div>

            <div className={styles.wrapper_total_text_item}>
              <div>
                <p className={styles.wrapper_total_text_item_p1}>Программы стажировки</p>
                <p className={styles.wrapper_total_text_item_p2}>Сезонные программы с реальными задачами для студентов профильных направлений</p>
              </div>
              <div className={styles.wrapper_total_text_item_btn}>
                <a href='/students/internShips'>
                  Перейти <span>&rarr;</span>
                </a>
              </div>
            </div>
          </div>

          <div className={styles.wrapper_total_text_education}>
            <div className={styles.wrapper_total_text_item}>
              <div>
                <p className={styles.wrapper_total_text_item_p1}>МГУ имени М. В. Ломоносова</p>
                <p className={styles.wrapper_total_text_item_p2}>«Регенеративная биомедицина»</p>
              </div>
              <div className={styles.wrapper_total_text_item_btn}>
                <a target='_blank' href='http://www.fbm.msu.ru/admissions/magistracy/'>
                  Перейти <span>&rarr;</span>
                </a>
              </div>
            </div>

            <div className={styles.wrapper_total_text_item}>
              <div>
                <p className={styles.wrapper_total_text_item_p1}>МФТИ</p>
                <p className={styles.wrapper_total_text_item_p2}>
                  «Современные технологии в коммерческой биофармацевтике»
                </p>
              </div>
              <div className={styles.wrapper_total_text_item_btn}>
                <a target='_blank' href='https://mipt.ru/dbmp/news/ao_generium_obyavlyaet_dopolnitelnyy_nabor_na_magisterskuyu_programmu_sovremennye_tekhnologii_v_komm/ao_generium_obyavlyaet_dopolnitelnyy_nabor_na_magisterskuyu_programmu_sovremennye_tekhnologii_v_komm'>
                  Перейти <span>&rarr;</span>
                </a>
              </div>
            </div>
          </div>

          <div className={styles.wrapper_total_text_education}>

            <div className={styles.wrapper_total_text_item}>
              <div>
                <p className={styles.wrapper_total_text_item_p1}>Петушинский колледж</p>
                <p className={styles.wrapper_total_text_item_p2}>
                  Программа обучения и трудоустройства аппаратчиков-операторов
                </p>
              </div>
              <div className={styles.wrapper_total_text_item_btn}>
                <a target='_blank' href='http://ппгк.рф'>
                  Перейти <span>&rarr;</span>
                </a>
              </div>
            </div>

            <div className={styles.wrapper_total_text_item}>
              <div>
                <p className={styles.wrapper_total_text_item_p1}>РУДН</p>
                <p className={styles.wrapper_total_text_item_p2}>«Создание и разработка лекарственных препаратов»</p>
              </div>
              <div className={styles.wrapper_total_text_item_btn}>
                <a target='_blank' href='https://innovativedrugs.ru/'>
                  Перейти <span>&rarr;</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <FormPopUpEducation
          checkDomenNameState={checkDomenNameState}
          setActiveForm={setActiveForm}
          season={season}
          setActivePopUp={setActivePopUp}
          retake={retake}
          setRetake={setRetake}
          captchaSiteKey={captchaSiteKey}
        />
      )}
    </>
  )
}

export default EducationBlock
